module.exports = __webpack_public_path__ + "static/media/vector1.056763d9.png";